import React, { useMemo } from 'react';
import HotelSearchPanel from './HotelSearchPanel';

// MakeMyTrip-style always-visible inline modify-search row for the hotel results page.
// Reuses HotelSearchPanel (same UI as homepage) but seeded from URL values and
// notifies the parent via onSearch instead of navigating.
const HotelModifySearch = ({ values, onSearch, compact = false }) => {
  const parsedDate = (s) => {
    if (!s) return null;
    const d = new Date(s);
    return Number.isNaN(d.getTime()) ? null : d;
  };
  const initialValues = useMemo(() => ({
    city: values.city || '',
    lat: values.lat ? parseFloat(values.lat) : null,
    lng: values.lng ? parseFloat(values.lng) : null,
    checkIn: parsedDate(values.check_in),
    checkOut: parsedDate(values.check_out),
    rooms: parseInt(values.rooms, 10) || 1,
    adults: parseInt(values.guests, 10) || 2,
    children: 0,
  }), [values.city, values.lat, values.lng, values.check_in, values.check_out, values.rooms, values.guests]);

  return (
    <div className="bg-white dark:bg-gray-900">
      <div className={`max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 ${compact ? 'py-1 sm:py-1' : 'py-2 sm:py-2.5'}`}>
        <HotelSearchPanel
          initialValues={initialValues}
          buttonLabel="SEARCH"
          compact={compact}
          onSubmit={(payload) => onSearch({
            city: payload.city,
            lat: payload.lat,
            lng: payload.lng,
            check_in: payload.check_in,
            check_out: payload.check_out,
            rooms: payload.rooms,
            guests: payload.guests,
          })}
        />
      </div>
    </div>
  );
};

export default HotelModifySearch;
